export default {
  errorDefault: 'Er is een fout opgetreden',
  unknown: 'Unknown',
};
